<template>
  <Header/>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-12 m-0 no-max-w home-div">
          <Toast/>
          <ConfirmDialog/>
          <DataTable :value="contents" :lazy="true" :paginator="true"
                     paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                     :rowsPerPageOptions="[5, 10, 20, 50, 100]" dataKey="id" :rows="10" ref="dt"
                     :totalRecords="contentsTotalRecords" :loading="loading" @page="onContentsPage($event)"
                     @sort="onContentsSort($event)" @filter="onContentsFilter($event)" responsiveLayout="scroll"
                     class="p-datatable-striped" v-model:filters="filters" filterDisplay="menu" removableSort
                     :globalFilterFields="['global', 'name', 'isActive', 'relationshipStatusIds']"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
            <template #header>
              <div class="d-flex justify-content-between">
                <div>
                  <Button type="button" icon="pi pi-plus" label="Add Content" class="p-button-info d-inline me-2"
                          @click="showNewContentModal = true"/>
                  <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)"/>
                </div>
                <div>
                  <Button type="button" icon="pi pi-filter-slash" label="Clear" class="p-button-outlined d-inline me-2"
                          @click="clearFilter()"/>
                  <span class="p-input-icon-left">
                    <i class="pi pi-search"/>
                    <InputText v-model="filters['global'].value" placeholder="Keyword Search" @change="getContents"/>
                  </span>
                </div>
              </div>
            </template>

            <template #empty> No daily contents found.</template>
            <template #loading> Loading daily contents data. Please wait.</template>
            <template v-for="(column) in columns" :key="column">
              <Column :field="column.field"
                      :header="column.header"
                      :style="[!column.selected ? 'display:none !important' : 'display:table-cell !important']"
                      :dataType="'text'" class="orphex-td d-flex align-items-center justify-content-center" style="font-size:14px"
              >
                <template #body="slotProps">
                  <span v-if="column.functionType === 'none' && slotProps.data && slotProps.data[column.field]">
              {{ slotProps.data[column.field] }}
            </span>
                  <span v-else-if="column.functionType === 'Date'">
              {{ formatDate(slotProps.data[column.field]) }}
            </span>
                  <span v-else-if="column.functionType === 'bool'">
                <div v-if="!slotProps.data[column.field]" style="background: #c61010;">
                  <span  style="color: white; padding:10px 5px">False</span>
                </div>
                <div v-else style="background: #59c610;">
                  <span  style="color: white; padding:10px 5px">True</span>
                </div>
            </span>
                  <template  v-else-if="column.functionType === 'scroll'">
                    <ScrollPanel style="width: 100%; height: 100px" class="custombar">
                      <span class="m-0">{{ slotProps.data[column.field] }}</span>
                    </ScrollPanel>
                  </template>
                  <span v-else-if="column.functionType === 'json'">
                    <ScrollPanel style="width: 100%; height: 100px" class="custombar">
                      <VueJsonPretty
                          :data="slotProps.data[column.field]"
                          :show-length="true"
                          :deep="2"
                          :highlight-mouseover-node="true"
                          :show-line="true"
                          :collapsed="false"
                      />
                    </ScrollPanel>
                  </span>
                  <span v-else-if="column.functionType === 'img'">
                      <img :src="slotProps.data[column.field]" class="w-100" @click="openModal(slotProps.data[column.field])"/>
                  </span>
                  <span v-else-if="column.functionType === 'ascendantSignId'" class="m-0">{{ this.signs.find(x => x.id == slotProps.data.ascendantSignId)?.name }} </span>
                  <span v-else-if="column.functionType === 'relationshipIds'" class="m-0">
                <div
                    v-if="this.relationshipIds.every(x => slotProps.data.relationshipStatusIds.includes(x)) || slotProps.data.relationshipStatusIds.length === 0">
                  <span class="badge bg-primary rounded-pill">All</span>
                </div>
                <div v-else>
                  <ScrollPanel style="width: 100%; height: 100px" class="custombar">
                    <div v-for="relationshipId in slotProps.data.relationshipStatusIds" :key="relationshipId">
                      <span class="mt-1">{{ this.relationships?.find(x => x.id == relationshipId)?.name }}</span>
                    </div>
                  </ScrollPanel>
                </div>
              </span>
                  <span v-else-if="column.functionType === 'occupationIds'" class="m-0">
                <div
                    v-if="this.occupationIds.every(x => slotProps.data.occupationIds.includes(x)) || slotProps.data.occupationIds.length === 0">
                  <span class="badge bg-primary rounded-pill">All</span>
                </div>
                <div v-else>
                  <ScrollPanel style="width: 100%; height: 100px" class="custombar">
                    <div v-for="occupationId in slotProps.data.occupationIds" :key="occupationId">
                      <span class="mt-1">{{ this.occupations?.find(x => x.id == occupationId)?.name }}</span>
                    </div>
                  </ScrollPanel>
                </div>
              </span>
                  <span v-else-if="column.functionType === 'gender'"  class="m-0">
                {{ this.genders.find(x => x.id == slotProps.data.gender)?.name }}
              </span>
                  <span v-else-if="column.functionType === 'crud'">
                      <Button v-tooltip.left="'Edit Translations'" v-if="column.translations" icon="pi pi-book" class="p-button p-button-sm me-2 my-2"  @click="showEditLanguage(slotProps.data.id)"/>

                      <Button v-tooltip.left="'Created'" v-if="column.created" icon="pi pi-plus" class="p-button-info p-button-sm me-2 my-2"
                              @click="$emit('created-modal', slotProps.data)" />
                      <Button v-tooltip.left="'Edit'" v-if="column.edit" icon="pi pi-pencil" class="p-button-warning p-button-sm me-2 my-2"
                              @click="openEditContent(slotProps.data.id)" />
                      <Button v-tooltip.left="'Delete'" v-if="column.delete" icon="pi pi-trash" class="p-button-danger p-button-sm me-2 my-2"
                              @click="deleteContent(slotProps.data.id)" />
                  </span>
                </template>
              </Column>
            </template>
          </DataTable>
        </div>
      </div>

      <Dialog header="Add Content" v-model:visible="showNewContentModal" modal :style="{ 'width': '40%' }">

        <div class="row mb-3 mt-3">
          <div class="col-md-12 form-group">
            <label class="d-block">Auto Translate*:</label>
            <InputSwitch v-model="newContent.autoTranslate" @change="updateAutoAudio"/>
          </div>

          <div class="col-md-12 form-group">
            <label class="d-block">Auto Audio Languages*:</label>
            <MultiSelect
                class="w-100"
                v-model="newContent.autoAudioLanguages"
                :options="supportedLanguages"
                optionLabel="name"
                optionValue="id"
                placeholder="Select Languages"
            />
          </div>

          <div class="col-md-12 form-group">
            <label class="d-block">Title*:</label>
            <InputText class="w-100" type="text" v-model="newContent.title"/>
          </div>

          <div class="col-md-12 form-group">
            <label class="d-block">Text*:</label>
            <Textarea class="w-100" type="text" rows="5" v-model="newContent.text"/>
          </div>
          <div class="col-md-12 form-group">
            <label class="d-block">Story Prefix:</label>
            <InputText class="w-100" type="text" v-model="newContent.storyPrefix"/>
          </div>
          <div class="col-md-12 form-group">
            <div class="d-flex gap-2 align-items-center mt-2">
              <label class="d-block">Order:</label>
              <ToolsPopover text="'Order' alanını kullanarak, içeriklerin uygulamada hangi sırayla görüneceğini belirleyebilirsiniz."/>
            </div>
            <InputNumber class="w-100" type="number" v-model="newContent.order"/>
          </div>

          <div class="col-md-6 form">
            <label class="d-block">Premium:</label>
            <InputSwitch v-model="newContent.isPremium"/>
          </div>

          <div class="col-md-6 form-group">
            <label class="d-block">General:</label>
            <InputSwitch v-model="newContent.isGeneral"/>
          </div>

          <div class="col-md-6 form-group" v-show="!newContent.isGeneral">
            <label class="d-block">Ascendant Sign:</label>
            <Dropdown v-model="newContent.ascendantSignId" :options="signs" optionLabel="name" optionValue="id"
                      placeholder="Select Sign"/>
          </div>

          <div class="col-md-12 form-group">
            <label class="d-block">Show After Date*:</label>
            <Calendar class="w-100" type="text" v-model="newContent.startDate"/>
          </div>
          <div class="col-md-12 form-group">
            <label class="d-block">Event Date*:</label>
            <Calendar class="w-100" type="text" v-model="newContent.endDate"/>
          </div>

          <div class="col-md-12 form-group">
            <label class="d-block">Photo Url*:</label>
            <InputText class="w-100" type="text" v-model="newContent.photoUrl"/>
          </div>

          <div class="col-md-6 form-group">
            <label class="d-block">Tags:</label>
            <MultiSelect class="w-100" v-model="newContent.categoryIds" :options="categories" optionLabel="name"
                         optionValue="id" placeholder="Select Tags"/>
          </div>

          <div class="col-md-6 form-group">
            <label class="d-block">Min Age:</label>
            <InputNumber class="w-100" mode="decimal" v-model="newContent.minAge"/>
          </div>
          <div class="col-md-6 form-group">
            <label class="d-block">Max Age:</label>
            <InputNumber class="w-100" mode="decimal" v-model="newContent.maxAge"/>
          </div>


          <div class="col-md-6 form-group">
            <label class="d-block">Gender:</label>
            <Dropdown class="w-100"
                      :options="[{ 'id': 0, 'value': 'All' }, { 'id': 1, 'value': 'Man' }, { 'id': 2, 'value': 'Woman' }]"
                      v-model="newContent.gender" optionLabel="value" optionValue="id"/>
          </div>

          <div class="col-md-6 form-group">
            <label class="d-block">Occupations:</label>
            <MultiSelect class="w-100" v-model="newContent.occupationIds" :options="occupations" optionLabel="name"
                         optionValue="id" placeholder="Select Occupations"/>
          </div>

          <div class="col-md-6 form-group">
            <label class="d-block">Relationship:</label>
            <MultiSelect class="w-100" :options="relationships" v-model="newContent.relationshipStatusIds"
                         optionLabel="name" optionValue="id"/>
          </div>
        </div>









        <footer class="d-flex justify-content-end">
          <Button label="Cancel" class="p-button-secondary me-2" @click="showNewContentModal = false"/>
          <Button label="Save" class="p-button-success" @click="addContent"/>
        </footer>
      </Dialog>


      <TranslationsModal
          :show="showEditLanguageModal"
          @hide="showEditLanguageModal = false"
          :contentId="editTranslationContentId"
      />

      <Dialog header="Edit Content" v-model:visible="showEditContent" modal :style="{ 'width': '40%' }">
        <div class="row">
          <div class="col-md-6 form-group">
            <label class="d-block">Premium:</label>
            <InputSwitch v-model="editContentModel.isPremium"/>
          </div>

          <div class="col-md-6 form-group">
            <label class="d-block">General:</label>
            <InputSwitch v-model="editContentModel.isGeneral"/>
          </div>

          <div class="col-md-6 form-group" v-show="!editContentModel.isGeneral">
            <label class="d-block">Ascendant Sign:</label>
            <Dropdown v-model="editContentModel.ascendantSignId" :options="signs" optionLabel="name" optionValue="id"
                      placeholder="Select Sign"/>
          </div>

          <div class="col-md-6 form-group">
            <label class="d-block">Min Age:</label>
            <InputNumber buttonLayout="horizontal" decrementButtonClass="p-button-secondary"
                         incrementButtonClass="p-button-secondary" incrementButtonIcon="pi pi-plus"
                         decrementButtonIcon="pi pi-minus"
                         mode="decimal" showButtons v-model="editContentModel.minAge"/>
          </div>
          <div class="col-md-6 form-group">
            <label class="d-block">Max Age:</label>
            <InputNumber buttonLayout="horizontal" decrementButtonClass="p-button-secondary"
                         incrementButtonClass="p-button-secondary" incrementButtonIcon="pi pi-plus"
                         decrementButtonIcon="pi pi-minus"
                         mode="decimal" showButtons v-model="editContentModel.maxAge"/>
          </div>
          <div class="col-md-6 form-group">
            <label class="d-block">Gender:</label>
            <Dropdown
                :options="[{ 'id': 0, 'value': 'All' }, { 'id': 1, 'value': 'Man' }, { 'id': 2, 'value': 'Woman' }]"
                v-model="editContentModel.gender" optionLabel="value" optionValue="id"/>
          </div>
          <div class="col-md-6 form-group">
            <label class="d-block">Relationship:</label>
            <MultiSelect :options="[{ 'id': 0, 'value': 'All' }, { 'id': 1, 'value': 'Single' },
            { 'id': 2, 'value': 'Married' }, { 'id': 3, 'value': 'Divorced' },
            { 'id': 4, 'value': 'Engaged' }, { 'id': 5, 'value': 'In Relationship' },
            { 'id': 6, 'value': 'Complicated' },
            { 'id': 7, 'value': 'Widowed' },
            { 'id': 8, 'value': 'Open Relationship' }]"
                         v-model="editContentModel.relationshipStatusIds" optionLabel="value" optionValue="id"/>
          </div>
          <div class="col-md-12 form-group">
            <label class="d-block">Occupations:</label>
            <MultiSelect v-model="editContentModel.occupationIds" :options="occupations" optionLabel="name"
                         optionValue="id" placeholder="Select Occupations"/>
          </div>
          <div class="col-md-6 form-group">
            <label class="d-block">Tags:</label>
            <MultiSelect v-model="editContentModel.categoryIds" :options="categories" optionLabel="name"
                         optionValue="id"
                         placeholder="Select House"/>
          </div>

          <div class="col-md-12 form-group">
            <label class="d-block">Show After Date:</label>
            <Datepicker class="w-100" type="text" v-model="editContentModel.startDate"/>
          </div>
          <div class="col-md-12 form-group">
            <label class="d-block">Event Date:</label>
            <Datepicker class="w-100" type="text" v-model="editContentModel.endDate"/>
          </div>

          <div class="col-md-12 form-group">
            <label class="d-block">Photo Url:</label>
            <InputText class="w-100" type="text" v-model="editContentModel.photoUrl"/>
          </div>
          <div class="col-md-12 form-group">
            <label class="d-block">Order:</label>
            <InputNumber class="w-100" type="number" v-model="editContentModel.order"/>
          </div>
          <div class="col-md-6 form-group">
            <label class="d-block">Tags:</label>
            <MultiSelect class="w-100" v-model="editContentModel.categoryIds" :options="categories" optionLabel="name"
                         optionValue="id" placeholder="Select Tags"/>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="showEditContent = false">
            Close
          </button>
          <Button label="Save" icon="pi pi-save" iconPos="left" @click="editContent()"/>
        </div>
      </Dialog>


    </div>
  </main>

  <div v-if="isModalOpen" class="modal-overlay" @click="isModalOpen = false">
    <div class="modal-content" @click.stop>
      <button class="close-btn" @click="isModalOpen = false">X</button>
      <img :src="modalImageUrl" alt="Full-size Photo" class="modal-image" style="width:100%; height:100%;max-height: 600px;"/>
    </div>
  </div>

</template>

<script>
import Header from "@/components/Header.vue";
import dayjs from "dayjs";
import "@vuepic/vue-datepicker/dist/main.css";
import InputText from "primevue/inputtext";
import {mapGetters} from "vuex";
import TranslationsModal from "../Modals/TranslationsModal.vue";
import VueJsonPretty from "vue-json-pretty";

export default {
  name: "Cosmic Events",
  components: {VueJsonPretty, Header, InputText, TranslationsModal},
  data() {
    return {
      selectedContentType: 'cosmic-event',
      contentTypes: [
        {id: "cosmic-event", name: "Cosmic Event"},
      ],
      loading: false,
      contentsTotalRecords: 0,
      contents: [],
      filters: {
        global: {value: null},
        name: {value: null},
        house: {value: null},
        gender: {value: null},
        relationshipStatusIds: {value: null},
        score: {value: []},
        occupation: {value: null},
        minAge: {value: null},
        maxAge: {value: null},
      },
      contentsLazyParams: {},
      showNewContentModal: false,
      showEditLanguageModal: false,
      showEditContent: false,
      newContent: {
        title: "",
        text: "",
        score: 1,
        storyPrefix: "",
        order: 0,
        houseId: null,
        ascendantSignId: null,
        gender: 0,
        minAge: 0,
        maxAge: 100,
        relationshipStatus: 0,
        autoTranslate: false,
        autoAudioLanguages: [],
      },
      editContentModel: {},
      messages: [],
      messageCount: 0,
      editLanguageModel: {},
      genders: [{id: 0, name: "All"}, {id: 1, name: "Man"}, {id: 2, name: "Woman"}],
      modalImageUrl: "",
      isModalOpen: false,

      columns: [
        {field: "id", header: "Id", functionType: "none", selected: true},
        {field: "order", header: "Order", functionType: "none", selected: true},
        {field: "title", header: "Title", functionType: "none", selected: true},
        {field: "text", header: "Text", functionType: "scroll", selected: true},
        {field: "photoUrl", header: "Photo Url", functionType: "img", selected: true},
        {field: "ascendantSignId", header: "Ascendant Sign Id", functionType: "ascendantSignId", selected: true},
        {field: "gender", header: "Gender", functionType: "gender", selected: true},
        {field: "minAge", header: "Min Age", functionType: "none", selected: true},
        {field: "maxAge", header: "Max Age", functionType: "none", selected: true},
        {field: "relationshipStatus", header: "Relationship Status", functionType: "none", selected: false},
        {field: "relationshipStatusIds", header: "Relationship Status Ids", functionType: "relationshipIds", selected: true},
        {field: "occupationIds", header: "Occupation Ids", functionType: "occupationIds", selected: true},
        {field: "startDate", header: "Start Date", functionType: "Date", selected: true},
        {field: "endDate", header: "End Date", functionType: "Date", selected: true},
        {field: "secondaryText", header: "Secondary Text", functionType: "none", selected: false},
        {field: "category", header: "Category", functionType: "none", selected: false},
        {field: "isVerified", header: "Is Verified", functionType: "json", selected: false},
        {field: "isGeneral", header: "Is General", functionType: "bool", selected: true},
        {field: "isPremium", header: "Is Premium", functionType: "bool", selected: true},
        {field: "backgroundMusicUrl", header: "Background Music Url", functionType: "none", selected: false},
        {field: "categoryIds", header: "Category Ids", functionType: "json", selected: false},
        {field: "createdDate", header: "Created Date", functionType: "Date", selected: true},
        {field: "lastUpdateDate", header: "Last Updat eDate", functionType: "Date", selected: true},
        {field: "storyPrefix", header: "Story Prefix", functionType: "none", selected: true},
        {field: "score", header: "Score", functionType: "none", selected: false},
        {field: "houseId", header: "House Id", functionType: "none", selected: false},
        {field: "Actions", header: "Actions", functionType: "crud", created: false, edit: true, delete: true, translations: true, selected: true},
      ]
    };
  },
  mounted() {
    this.contentsLazyParams = {
      first: 0,
      rows: this.$refs.dt.rows,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    this.getContents();
    this.newContent.categoryIds = this.categories.map(category => category.id);
    this.newContent.occupationIds = this.occupations.map(occupation => occupation.id);
    this.newContent.relationshipStatusIds = this.relationships.map(relationship => relationship.id);
  },
  computed: {
    ...mapGetters(['occupations', 'signs', 'houses', 'relationships', 'occupationIds', 'relationshipIds', 'categories', 'supportedLanguages']),
  },
  watch: {},
  methods: {
    getContents() {
      this.loading = true;

      var filters = {};

      for (const [key] of Object.entries(this.contentsLazyParams.filters)) {
        filters[key] = this.contentsLazyParams.filters[key].value;
      }
      this.$appAxios
          .post("admin/content/list/" + this.selectedContentType, {
            first: this.contentsLazyParams.first,
            rows: this.contentsLazyParams.rows,
            sortField: this.contentsLazyParams.sortField,
            sortOrder: this.contentsLazyParams.sortOrder,
            page: this.contentsLazyParams.page,
            filters: JSON.stringify(filters),
          })
          .then((resp) => {
            this.contents = resp.data.data;
            this.contentsTotalRecords = resp.data.totalRecords;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    onContentsPage(event) {
      this.contentsLazyParams = event;
      this.contentsLazyParams.filters = this.filters;
      this.getContents();
    },
    onContentsSort(event) {
      this.contentsLazyParams = event;
      this.contentsLazyParams.filters = this.filters;
      this.getContents();
    },
    onContentsFilter() {
      this.contentsLazyParams.filters = this.filters;
      this.getContents();
    },
    clearFilter() {
      for (const [key] of Object.entries(this.filters)) {
        this.filters[key].value = null;
      }
      this.getContents();
    },
    formatDate(dateString) {
      if (dateString == null) {
        return "";
      }

      const date = dayjs(dateString);
      return date.format("DD/MM/YYYY HH:mm");
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    showEditLanguage(id) {
      this.editTranslationContentId = id;
      this.showEditLanguageModal = true;
    },
    editLanguage() {
      if (!(this.editLanguageModel.text && this.editLanguageModel.language)) {
        this.messages = [{severity: 'warn', content: 'Required fields must be entered.', id: this.messageCount++}];
        return;
      }
      this.$appAxios.put("admin/content/translation",
          {
            id: this.editLanguageModel.id,
            title: this.editLanguageModel.title,
            text: this.editLanguageModel.text,
            language: this.editLanguageModel.language,
            isVerified: this.editLanguageModel.isVerified,
          }
      ).then(() => {
        this.showEditLanguageModal = false;
        this.$toast.add({severity: 'success', summary: 'Success', detail: 'Language info updated', life: 3000});
        this.getContents();
      })
          .catch(() => {
            this.showEditLanguageModal = false;
            this.$toast.add({severity: 'error', summary: 'Error', detail: 'Language info not updated', life: 3000});
          })
    },
    openEditContent(id) {
      this.$appAxios.get("admin/content/" + id)
          .then(resp => {
            this.editContentModel = resp.data;
            console.log(this.editContentModel)
            this.showEditContent = true;
          })
          .catch(err => {
            console.log(err)
          });
    },
    editContent() {
      if (!(this.editContentModel.isGeneral || this.editContentModel.ascendantSignId)) {
        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Sign is required', life: 3000});
        return;
      }

      this.$appAxios.put("admin/content",
          {
            id: this.editContentModel.id,
            ascendantSignId: this.editContentModel.isGeneral ? null : this.editContentModel.ascendantSignId,
            houseId: this.editContentModel.houseId,
            gender: this.editContentModel.gender,
            minAge: this.editContentModel.minAge,
            maxAge: this.editContentModel.maxAge,
            score: this.editContentModel.score,
            relationshipStatusIds: this.editContentModel.relationshipStatusIds,
            occupationIds: this.editContentModel.occupationIds,
            type: this.selectedContentType,
            isGeneral: this.editContentModel.isGeneral,
            startDate: this.editContentModel.startDate,
            endDate: this.editContentModel.endDate,
            photoUrl: this.editContentModel.photoUrl,
            categoryIds: this.editContentModel.categoryIds,
            isPremium: this.editContentModel.isPremium,
            order: this.editContentModel.order,
          }
      ).then(() => {
        this.showEditContent = false;
        this.$toast.add({severity: 'success', summary: 'Success', detail: 'Content updated', life: 3000});
        this.getContents();
      })
          .catch(() => {
            this.showEditContent = false;
            this.$toast.add({severity: 'error', summary: 'Error', detail: 'Content not updated', life: 3000});
          })
    },
    deleteContent(id) {
      this.$confirm.require({
        message: 'Are you sure you want to delete the content?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.$appAxios.delete("admin/content/" + id)
              .then(() => {
                this.$toast.add({severity: 'success', summary: 'Success', detail: 'Content deleted', life: 3000});
                this.getContents();
              })
              .catch(() => {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Content could not be deleted',
                  life: 3000
                });
              })
        },
        reject: () => {
        }
      });
    },
    updateAutoAudio() {
      if (!this.newContent.autoTranslate) {
        this.newContent.autoAudio = false;
      }
    },
    addContent() {
      if (!(this.newContent.isGeneral || this.newContent.ascendantSignId)) {
        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Sign is required', life: 3000});
        return;
      }

      this.$appAxios.post("admin/content/v2/cosmic-event", {
        type: this.selectedContentType,
        startDate: this.newContent.startDate,
        endDate: this.newContent.endDate,
        photoUrl: this.newContent.photoUrl,
        title: this.newContent.title,
        text: this.fixNewlines(this.newContent.text),
        categoryIds: this.newContent.categoryIds,
        ascendantSignId: this.newContent.isGeneral ? null : this.newContent.ascendantSignId,
        isPremium: this.newContent.isPremium,
        isGeneral: this.newContent.isGeneral,
        storyPrefix: this.newContent.storyPrefix,
        order: this.newContent.order,
        autoTranslate: this.newContent.autoTranslate,
        autoAudioLanguages: this.newContent.autoAudioLanguages,


        minAge: this.newContent.minAge,
        maxAge: this.newContent.maxAge,
        gender: this.newContent.gender,
        relationshipStatusIds: this.newContent.relationshipStatusIds,
        occupationIds: this.newContent.occupationIds,
      })
          .then(() => {
            this.$toast.add({severity: 'success', summary: 'Success', detail: 'Content added', life: 3000});
            this.getContents();
            this.showNewContentModal = false;
          })
          .catch(err => {
            console.log(err)
          });
    },
    openModal(imageUrl) {
      console.log("imageUrl",imageUrl)
      this.modalImageUrl = imageUrl;
      this.isModalOpen = true;
    },

    fixNewlines(text) {
      let fixed = text.replace(/\\n/g, '\n');
      fixed = fixed.replace(/\/n/g, '\n');
      return fixed;
    }
  },
};
</script>
<style scoped>
.p-button-sm {
  height: 35px;
  width: 35px;
  font-size: 0.875rem;
  padding: 0.7rem;
}

.p-disabled,
.p-component:disabled {
  opacity: 0.8;
}

.p-dropdown {
  min-width: 200px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* Transparan arka plan */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Modal İçerik */
.modal-content {
  position: relative;
  max-width: 35%;
  width: 100%;
  background-color: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
}

.modal-image {
  width: 100%;
  height: auto;
}

/* Kapatma Butonu */
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  color: white;
  cursor: pointer;
}

</style>
